<template>
    <ContentOrLoading>
        <b-row>
            <template v-if="precios.length">
                <b-col cols="12">
                    <TitleComponent title="1. Nuevas altas sin recinto" subtitle="- Selecciona la cantidad de abonos:" />
                </b-col>
                <b-col cols="12" lg="8">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Tipo de abono</th>
                                <th>Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(precio, index) in precios">
                                <tr :key="index">
                                    <td>{{ precio.descripcion }}</td>
                                    <td>
                                        <div class="form-group">
                                            <select class="form-control" v-model="precio.units" :disabled="disabled">
                                                <option calue="0">0</option>
                                                <template v-for="i in maxAbonos(precio)">
                                                    <option :key="i" :value="i">{{ i }}</option>
                                                </template>                                            
                                            </select>
                                        </div>                               
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </b-col>
                <b-col cols="12" lg="4" v-if="precios.some(precio => precio.units > 0)">
                    <b-row>
                        <b-col cols="12" class="text-center">
                            <h3>TUS ABONOS</h3>
                        </b-col>
                        <b-col cols="12">
                            <template v-for="(precio, index) in precios">
                                <p class="bg-secondary mb-2 p-2" :key="index" v-if="precio.units > 0">
                                    {{ ++index }}. {{ precio.descripcion }} x{{ precio.units }}
                                </p>
                            </template>
                        </b-col>
                        <b-col cols="12">
                            <Button id="continuar-paso1" class="btn-block" @click="bloquearAbonos" :disabled="disabled || loading">
                                CONTINUAR COMPRA
                            </Button>
                        </b-col>
                    </b-row>
                </b-col>
            </template>
            <b-col v-else cols="12">
                <h3>No hay ningún tipo de abono creado para realizar una compra.</h3>
            </b-col>
        </b-row>
    </ContentOrLoading>
</template>


<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';

    export default {
        props: {
            precios: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false
            };
        },
        methods: {
            bloquearAbonos() {
                this.$emit('terminado');
            },
            maxAbonos(precio) {
                var tope = 20;

                if(precio.stock < tope) {
                    tope = precio.stock;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        components: {
            TitleComponent
        }
    }
</script>